"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageAnnualYield$ = exports.AverageAnnualYield$outboundSchema = exports.AverageAnnualYield$inboundSchema = void 0;
exports.averageAnnualYieldToJSON = averageAnnualYieldToJSON;
exports.averageAnnualYieldFromJSON = averageAnnualYieldFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.AverageAnnualYield$inboundSchema = z.object({
    average_annual_yield: z.number(),
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_annual_yield": "averageAnnualYield",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.AverageAnnualYield$outboundSchema = z.object({
    averageAnnualYield: z.number(),
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageAnnualYield: "average_annual_yield",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AverageAnnualYield$;
(function (AverageAnnualYield$) {
    /** @deprecated use `AverageAnnualYield$inboundSchema` instead. */
    AverageAnnualYield$.inboundSchema = exports.AverageAnnualYield$inboundSchema;
    /** @deprecated use `AverageAnnualYield$outboundSchema` instead. */
    AverageAnnualYield$.outboundSchema = exports.AverageAnnualYield$outboundSchema;
})(AverageAnnualYield$ || (exports.AverageAnnualYield$ = AverageAnnualYield$ = {}));
function averageAnnualYieldToJSON(averageAnnualYield) {
    return JSON.stringify(exports.AverageAnnualYield$outboundSchema.parse(averageAnnualYield));
}
function averageAnnualYieldFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AverageAnnualYield$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AverageAnnualYield' from JSON`);
}
//# sourceMappingURL=averageannualyield.js.map